



import {Component, Vue} from 'vue-property-decorator';

Component.registerHooks([
  "beforeRouteUpdate"
]);

@Component({

})
export default class MainLayout extends Vue {
}
